import { Alert } from "@mui/material"
import { DevFatalErrorPage } from '@cedarjs/web/dist/components/DevFatalErrorPage'

// This page will be rendered when an error makes it all the way to the top of the
// application without being handled by a Javascript catch statement or React error
// boundary.
//
// You can modify this page as you wish, but it is important to keep things simple to
// avoid the possibility that it will cause its own error. If it does, Redwood will
// still render a generic error page, but your users will prefer something a bit more
// thoughtful. =)

export default DevFatalErrorPage ||
  (({error}) => (
    <main>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            html, body {
              margin: 0;
            }
            html * {
              box-sizing: border-box;
            }
            main {
              display: flex;
              align-items: center;
              font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
              text-align: center;
              background-color: #ced9e8;
              height: 100vh;
            }
            section {
              max-width: 24rem;
              width:100%;
              padding: 1rem;
              margin: 0 auto;
              
            }
            
            section svg {
              width: 8rem;
              margin-bottom: 1rem;
              fill: #42a8df;
            }
            h1 {
              font-size: 2rem;
              font-weight: 200;
              color: #2D3748;
            }
            h2 {
              font-size: 1.3rem;
              font-weight: 300;
              color: #2D3748;
            }
            main {
                background: linear-gradient(-45deg, #ffccc9, #faebcb, #fef8ec, #fee3e2);
                
                background-size: 800% 800%;
      
                animation: GradientAnimation 45s ease infinite;
            }
      
            @keyframes GradientAnimation {
              0% {
                background-position: 0% 50%;
              }
              50% {
                background-position: 100% 50%;
              }
              100% {
                background-position: 0% 50%;
              }
            }
            `,
        }}
      />
      <section>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"/>
        </svg>
        <h1>Actualisez la page</h1>
        <h2>Si vous pensez qu'il s'agit d'une erreur, contactez l'équipe</h2>
        {error && <Alert severity="error" className="whitespace-nowrap">{JSON.stringify(error,null,2)}</Alert>}
      </section>
    </main>
  ))
